import { useEffect } from 'react';

export const useClickOutside = (ref, onOutsideClick) => {
    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (!ref.current?.contains(e.target)) {
                onOutsideClick();
            }
        };

        window.addEventListener('click', handleOutsideClick);

        return () => {
            window.removeEventListener('click', handleOutsideClick);
        };
    }, [onOutsideClick]);
};
